// extracted by mini-css-extract-plugin
export default {"container":"YF-z","disabled":"ZF-z","bgBlack":"_F-z","content":"aG-z","countdown":"bG-z","topCaption":"cG-z","topHeading":"dG-z","heading":"eG-z","copy":"fG-z"};